export enum PaymentSystem {
  ShareIT = 'ShareIT',
  FastSpring = 'FastSpring',
  Virtual = 'Virtual',
  AWSMarketplace = 'AWSMarketplace',
  Stripe = 'Stripe'
}
